/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Glen Vallejo",
  title: "Hola, soy Glen",
  subTitle: emoji(
    "Un apasionado desarrollador de software Full Stack 🚀 con experiencia en la creación de soluciones computacionales de alto rendimiento."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1ofFdKF_mqscH8WvXkSObnVvC9kK7Ldlu/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  linkedin: "https://www.linkedin.com/in/glen-vallejo/",
  gmail: "glenvallejom@gmail.com",
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "Lo que hago",
  subTitle: "DESARROLLADOR FULL STACK APASIONADO QUE QUIERE EXPLORAR TODA TECNOLOGÍA",
  skills: [
    emoji(
      "⚡ Desarrollo de software robusto y altamente interactivo para automatizar procesos empresariales"
    ),
    emoji(
      "⚡ Diseño e implementación de aplicaciones web modernas con React, Vite y PrimeFaces"
    ),
    emoji(
      "⚡ Creación de APIs RESTful con .NET 8, arquitectura hexagonal y Entity Framework"
    ),
    emoji(
      "⚡ Desarrollo móvil multiplataforma con Flutter, Xamarin Forms y React Native"
    ),
    emoji(
      "⚡ Integración de CI/CD con GitLab, Kubernetes y Nginx para despliegues escalables"
    ),
    emoji(
      "⚡ Administración y optimización de bases de datos SQL Server, MySQL y PostgreSQL"
    ),
    emoji(
      "⚡ Experiencia en metodologías ágiles (SCRUM) y liderazgo de equipos de desarrollo"
    )
  ],


  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [

    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },

    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "C#",
      fontAwesomeClassname: "fas fa-code" // no hay ícono oficial de C#, este es el más usado
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "kubernetes",
      fontAwesomeClassname: "fas fa-project-diagram" // ícono alternativo para k8s
    },
    {
      skillName: "git",
      fontAwesomeClassname: "fab fa-git-alt"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};


const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Universidad de Guayaquil",
      logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQF7HOTx0ldKESn_PoiM38f03415hF3018XyC0iT3Y53LQCFZi8_m8Fj6iy-D_jRuVAHjQ&usqp=CAU",
      subHeader: "Ingeniero en sistemas computacionales",
      duration: "Abril 2016 - Abril 2021",
      desc: "",
      descBullets: null
    },
    {
      schoolName: "Colegio Particular Mixto Seis de Marzo",
      logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTJDJEuOyuOuigle9FFwf78CnQ-wdMLSA0oQw&s",
      subHeader: "Bachiller",
      duration: "Fin - Marzo 2016",
      desc: "",
      descBullets: null
    }

  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Diseño GUI", //Insert stack or technology you have experience in
      progressPercentage: "80%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "100%"
    },
    {
      Stack: "Frontend",
      progressPercentage: "100%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [{
    role: "Analista programador",
    company: "Naturisa S.A.",
    companylogo: "https://media.licdn.com/dms/image/v2/C4E0BAQH70i-9EsV6FQ/company-logo_200_200/company-logo_200_200/0/1677269629727/naturisa_ec_logo?e=1759968000&v=beta&t=mMTeVhCEu5D95iFsSSEU7CkpdOSXdbfeJ5OQAOrtfvU",
    date: "Febrero 2022 – Actualmente",
    descBullets: [
      "Responsable técnico de proyectos, coordinando equipos de desarrollo, asignando tareas, guiando técnicamente al equipo y supervisando el cumplimiento de entregables en todas las fases del ciclo de vida del desarrollo de software, bajo metodologías ágiles.",
      "Liderazgo en el desarrollo de software de alto rendimiento, llevando a cabo exhaustivos análisis de requerimientos, diseñando soluciones, y ejecutando tareas de programación mediante la aplicación de las tendencias tecnológicas.",
      "Desarrollo de aplicaciones web utilizando React con Vite, PrimeFaces y DevExpress.",
      "Implementación de APIs RESTful con .NET 8, empleando Swagger, Entity Framework y arquitectura hexagonal para garantizar escalabilidad y mantenibilidad.",
      "Aplicación de la metodología ágil SCRUM para optimizar los procesos de desarrollo, asegurando entregas de alta calidad dentro de plazos establecidos.",
      "Competencia en la gestión de bases de datos, asegurando un almacenamiento íntegro, eficiente y una recuperación precisa de la información.",
      "Control de versiones con GitLab, promoviendo una colaboración efectiva y una adecuada gestión de cambios en los proyectos.",
      // "Automatización de procesos de integración y despliegue continuo (CI/CD) con GitLab, utilizando Kubernetes y Nginx."
    ]
  },
  {
    role: "Analista programador",
    company: "Almacenes De Prati S.A.",
    companylogo: "https://yt3.googleusercontent.com/ytc/AIdro_mK8OKRdCoYd3z4VisYv5n05WvSYntkZ1-TtO5yoN23iCU=s176-c-k-c0x00ffffff-no-rj",
    date: "Febrero 2022 – Octubre 2024",
    descBullets: [
      "Contribuir al desarrollo de sistemas de variada complejidad, llevando a cabo exhaustivos análisis de requerimientos, diseñando soluciones, y ejecutando tareas de programación mediante la aplicación de las más recientes tecnologías de la información.",
      "Desarrollo de aplicaciones móviles con Xamarin Forms",
      "Desarrollo de soluciones Web y de escritorio con .Net",
      "Aplicación de la metodología ágil SCRUM para impulsar la eficiencia en los procesos de desarrollo, asegurando entregas de alta calidad en plazos ajustados.",
      "Desarrollador Full Stack, creando soluciones integrales y funcionales.",
      "Realizar mantenimiento periódico de sistemas preexistentes, garantizando su funcionamiento óptimo y aplicando mejoras continuas para responder a las necesidades cambiantes.",
      "Competencia en la gestión de bases de datos, asegurando un almacenamiento íntegro, eficiente y una recuperación precisa de la información.",
      "Desarrollo de programas Z en ABAP – SAP",
      "Control efectivo de versiones utilizando Git y Azure DevOps, facilitando la colaboración en equipo y la gestión de cambios en los proyectos.",
      "Atención de requerimientos designados por el jefe inmediato"
    ]
  },
  {
    role: "Docente de Desarrollo de Software",
    company: "Instituto Superior Tecnológico Guayaquil",
    companylogo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRD__YfwqrOhZX3kjoBeDwWRm63cBBUY8JasA&s",
    date: "Junio 2022 – Mayo 2025",
    descBullets: [
      "Enseñanza de Programación Orientada a Objetos, Análisis y Diseño de Sistemas, y Desarrollo de Aplicaciones Móviles, guiando a los estudiantes en conceptos fundamentales y técnicas modernas de desarrollo de software.",
      "Fomento de la reflexión ética y profesional en el ámbito tecnológico, abordando dilemas reales para fortalecer la responsabilidad en el ejercicio profesional.",
      "Planificación de clases orientadas a maximizar el aprendizaje activo, incorporando principios de gestión de proyectos para promover la aplicación práctica en entornos reales de desarrollo"
    ]
  },
  {
    role: "Analista /Programador Android y Backend Api’s Rest",
    company: "Pure Technology",
    companylogo: "https://pbs.twimg.com/profile_images/824083595023319040/Iim_XD_m_400x400.jpg",
    date: "Julio 2019 – Febrero 2022",
    descBullets: [
      "Levantamiento de información y análisis de requerimientos.",
      "Desarrollo de aplicaciones móviles Android (Java – Kotlin – Flutter)",
      "Realizar mantenimiento de los sistemas ya existentes y de las actualizaciones de los mismos.",
      "Asistir y capacitar a usuarios de las aplicaciones desarrolladas",
      "Identificar propuestas e iniciativas de mejora de procesos y operación del departamento.",
      "Brindar soporte a usuarios que van a usar los nuevos sistemas",
      "Retroalimentar administración de sistemas a los usuarios finales.",
      "Manejo de base de datos",
      "Control de versiones con Git"
    ]
  }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Proyectos relevantes",
  subtitle: "Algunos de los proyectos en los que participé.",
  projects: [
    {
      image: "https://media.licdn.com/dms/image/v2/C4E0BAQH70i-9EsV6FQ/company-logo_200_200/company-logo_200_200/0/1677269629727/naturisa_ec_logo?e=1759968000&v=beta&t=mMTeVhCEu5D95iFsSSEU7CkpdOSXdbfeJ5OQAOrtfvU",
      projectName: "Portal de Compras",
      projectDesc: "Plataforma web para la gestión de compras en Naturisa: registro de solicitudes, asignación de compradores, análisis comparativo de precios, administración de contratos marco y control de flujos de liberación, con integración directa a SAP.",
    },
    {
      image: "https://play-lh.googleusercontent.com/M5Io2DYvGionymctDj4mCIlN88HuGYp5MMSFybc1O0AACZe_kfNo3Wwyw2nGnkq6ew",
      projectName: "POS Digital",
      projectDesc: "Apliación de punto de venta (Movil y Desktop), hecha en Xamarin Forms",

    },
    {
      image: "https://blogs.encamina.com/piensa-en-software-desarrolla-en-colores/wp-content/uploads/sites/21/2015/10/xamarin-logo.png",
      projectName: "ADP móvil",
      projectDesc: "Aplicación móvil que se integra a SAP con distintos módulos referentes a inventario, despacho y transferencia de mercadería entre tiendas.",
    },
    {
      image: "https://pbs.twimg.com/profile_images/824083595023319040/Iim_XD_m_400x400.jpg",
      projectName: "Carrito de Compras",
      projectDesc: "Aplicación móvil de comercio electrónico para gestionar pedidos, productos y pagos de manera intuitiva y segura.",
    },
    {
      image: require("./assets/images/ic_launcher.png"),
      projectName: "Ubicación de contenedores",
      projectDesc: "Aplicación móvil para el tracking de los contenedores dentro del almacen portuario",
    },
    {
      image: require("./assets/images/ic_launcher.png"),
      projectName: "Eir Electrónico",
      projectDesc: "Aplicación móvil para el control e inspección de contenedores en bodega portuaria",
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        { name: "Certification", url: "" },
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Curriculum",
  subtitle: "Descarga mi hoja de vida",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contáctame ☎️"),
  subtitle:
    "¿Discutir un proyecto o simplemente quieres saludar? Mi bandeja de entrada está abierta para todos.",
  number: "+593-960454285",
  email_address: "glenvallejom@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
